import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { employeeService } from '../services/employeeService';
import ProfileHeader from '../component/profile/ProfileHeader';
import PersonalInfoCard from '../component/profile/PersonalInfoCard';
import EmploymentDetailsCard from '../component/profile/EmploymentDetailsCard'; // Naya component
import EmployeeAddressesCard from '../component/profile/EmployeeAddressesCard';
import EmployeeContactsCard from '../component/profile/EmployeeContactsCard';
import EmployeeSkillsCard from '../component/profile/EmployeeSkillsCard';
import EmployeeDocumentsCard from '../component/profile/EmployeeDocumentsCard';

export default function EmployeeFullProfilePage() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isEditable = true;

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        setLoading(true);
        const response = await employeeService.getEmployeeByUuid(uuid);
        setEmployee(response.data);
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError('Failed to load employee profile.');
      } finally {
        setLoading(false);
      }
    };

    if (uuid) fetchEmployeeDetails();
  }, [uuid]);

  if (loading) return <div className="p-8 text-center text-xs font-semibold text-slate-500">Loading profile...</div>;
  if (error || !employee) return <div className="p-8 text-center text-rose-600 text-xs font-semibold">{error || 'Not found'}</div>;

  return (
    <div className="w-full h-full p-6 md:p-8 flex flex-col gap-6 bg-slate-50/60 overflow-y-auto">
      
      {/* Back Button */}
      <div>
        <button
          onClick={() => navigate('/employees')}
          className="inline-flex items-center gap-2 px-3.5 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-semibold shadow-xs transition cursor-pointer"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Directory
        </button>
      </div>

      {/* Header Banner */}
      <ProfileHeader employee={employee} />

      {/* Sequenced Grid for Profile Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PersonalInfoCard employee={employee} />
        <EmploymentDetailsCard employeeUuid={uuid} />
        <EmployeeAddressesCard employeeUuid={uuid} canEdit={isEditable} />
        <EmployeeContactsCard employeeUuid={uuid} canEdit={isEditable} />
        <EmployeeSkillsCard employeeUuid={uuid} canEdit={isEditable} />
        <EmployeeDocumentsCard employeeUuid={uuid} canAdd={isEditable} />
      </div>

    </div>
  );
}